import * as React from 'react';
import { Routes, Route } from "react-router-dom";
import './App.css'; 
import 'bootstrap/dist/css/bootstrap.min.css';
 
import Login from './auth/Login';
 
import Signup from './auth/Signup';
import ForgotPassword from './auth/ForgotPassword';
 
 
 

import Admin from './dashboard/Admin/Admin';

import InviteUsers from './dashboard/Admin/InviteUsers';

import Main from './dashboard/Admin/Main';

import User_Management from './dashboard/Admin/User_Management';
import Add_Keyword from './dashboard/Admin/Add_Keyword';

 
 


function App() {
  return (
    <div className="App">
   
    <Routes> 
    <Route path="/" exact element={<Login />}/>
     
    <Route path="/auth/login" element={<Login />}/>
    <Route path="/auth/signup" element={<Signup />}/>
     
    <Route path="/auth/password" element={<ForgotPassword />}/> 
     
    
    <Route path="/admin"  element={<Admin />} />
    <Route path="/admin/:route" element={<Main />} />
    <Route path="/admin/Invite_Users"  element={<InviteUsers />} />
    <Route path="/admin/User_Management"  element={<User_Management />} />
    <Route path="/admin/Add_Keyword"  element={<Add_Keyword />} />
   
     


    
    </Routes>
    
    </div>
  );
}

export default App;
